import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import { getTestIds } from '../../../../../utils/TestIds';
import { InlineControl } from '../../../../TableList/InlineControl';
import { useTokensField } from '../../../../TokenText/useTokensField';
import styles from '../cells.module.scss';
export function CellTextInput(param) {
    let { value, placeholder, tokens, editing, testId } = param;
    const testIds = getTestIds(testId);
    const [draft, setDraft] = useState(value);
    const [isEditing, setIsEditing] = useState(false);
    const committed = useRef(value);
    const isReverting = useRef(false);
    useEffect(()=>{
        committed.current = value;
        setDraft(value);
    }, [
        value
    ]);
    const placedTokens = tokens == null ? undefined : _object_spread_props(_object_spread({}, tokens), {
        adornment: _object_spread_props(_object_spread({}, tokens.adornment), {
            className: cn(styles.tokenTrigger, tokens.adornment.className)
        }),
        picker: _object_spread({
            testId: testIds.picker()
        }, tokens.picker)
    });
    const field = useTokensField({
        tokens: placedTokens,
        onValueChange: setDraft,
        testIds: {
            adornment: testIds.adornment()
        }
    });
    // WHY: Escape makes InlineInput both revert and blur, and each reaches this cell as a save.
    const revert = ()=>{
        isReverting.current = true;
        requestAnimationFrame(()=>{
            isReverting.current = false;
            setDraft(committed.current);
        });
    };
    const commit = (next)=>{
        if (isReverting.current || field.isPickerOpen || next === committed.current) return;
        committed.current = next;
        editing.onCommit(next);
    };
    const showsAdornment = field.adornment != null && (isEditing || field.isPickerOpen);
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.editorHost, {
            [styles.withTokenAdornment]: showsAdornment
        }),
        children: [
            /*#__PURE__*/ _jsx(InlineControl.Input, {
                ref: field.inputRef,
                value: draft,
                error: editing.errorText != null,
                errorText: editing.errorText,
                errorTextInTooltip: true,
                className: styles.editor,
                inputProps: {
                    placeholder,
                    onKeyDown: (event)=>{
                        var _field_onKeyDown;
                        if (event.key === 'Escape') revert();
                        (_field_onKeyDown = field.onKeyDown) === null || _field_onKeyDown === void 0 ? void 0 : _field_onKeyDown.call(field, event);
                    },
                    onClick: field.onClick
                },
                onChange: (next)=>setDraft(String(next)),
                onFocus: ()=>setIsEditing(true),
                onSave: (next)=>commit(String(next)),
                onBlur: (event)=>{
                    commit(event.currentTarget.value);
                    requestAnimationFrame(()=>{
                        if (!field.isPickerOpen) setIsEditing(false);
                    });
                },
                testId: testId
            }),
            showsAdornment && field.adornment,
            field.picker
        ]
    });
}
